import AuthRequest from "./AuthRequest";

const baseUrl = "/api/kinus/reporting";

const KinusReportingApi = {
  getList: () => {
    return AuthRequest.get(baseUrl + "/list", {});
  },
  /** @param {number} startSession
   * @param {number} endSession
   */
  getByRange: (startSession, endSession) => {
    return AuthRequest.get(baseUrl + "/byrange", { startSession, endSession });
  },
  /** @param {number} year */
  getSingle: (year) => {
    return AuthRequest.get(baseUrl + `/${year}`, { year });
  },
};

export default KinusReportingApi;
